'use strict';

// Include helpers
// We don't have globbing support for require calls, so include them separately
require('./helpers/classnames.js');
require('./helpers/prevent-ie-transitions-on-load.js');
require('./helpers/vh-mobile-device-fix.js');

// Include polyfills
// We don't have globbing support for require calls, so include them separately
require('./polyfills/array-find-for-ie11.js');
require('./polyfills/custom-events-for-ie11.js');
require('./polyfills/element-classlist-for-ie11.js');
require('./polyfills/element-matches.js');
require('./polyfills/get-scrolling-element.js');
require('./polyfills/string-includes.js');
require('./polyfills/string-starts-with.js');

// Import smooth scroll
// For: IE 11, Chrome < 61, Firefox < 36, Safari
require('smoothscroll-polyfill').polyfill();

// Intersection observer polyfill - about 20kb raw, but we need it
window.IntersectionObserver = window.IntersectionObserver || require('intersection-observer-polyfill/dist/IntersectionObserver');

// Web animations polyfill - about 50kb raw, so only use if you need it
require('web-animations-js');



// WEBPACK FOOTER //
// ./website/vendor/scripts/fabrique/base.js